export function getNetworksList(params) {
  return this.$api.get('/network/list', params)
    .then(({ data }) => {
      return data
    })
    .catch(error => Promise.reject(error))
}

export default {
  methods: {
    getTradingNetworks(params) {
      return this.$api.get('/networks', params)
        .then(({ data }) => {
          return data
        })
        .catch(error => Promise.reject(error))
    },

    createTradingNetwork(params) {
      return this.$api.post('network/0', params)
        .then(({ data }) => {
          return data
        })
        .catch(error => Promise.reject(error))
    },

    getTradingNetwork(id) {
      return this.$api.get('network/' + id)
        .then(({ data }) => {
          return data
        })
        .catch(error => Promise.reject(error))
    },

    updateTradingNetwork(id, params) {
      return this.$api.post('network/' + id, params)
        .then(({ data }) => {
          return data
        })
        .catch(error => Promise.reject(error))
    }
  }
}

export function tradingNetworks(api) {
  return {
    allList: (id, params) => {
      return api.get('/network/list')
        .then(({ data }) => {
          return data
        })
        .catch(error => Promise.reject(error))
    }
  }
}
